export default {
  notificationChannels: 'Kanály notifikácií',
  userSubscription: 'Predplatné používateľov',
};
